<template>
  <v-list-item dense>
    <v-list-item-icon>
      <v-icon :color="permission ? 'success' : 'error'">
        {{ permission ? 'fal fa-check-circle' : 'fal fa-times-circle' }}
      </v-icon>
    </v-list-item-icon>
    <v-list-item-content>
      {{ permission ? `Can ${can}` : cannot }}
    </v-list-item-content>
  </v-list-item>
</template>
<script>
export default {
  props: {
    permission: {
      type: Boolean,
      required: true,
    },
    can: {
      type: String,
      required: true,
    },
  },
  computed: {
    cannot() {
      return `Cannot ${this.can}`
    }
  }
}
</script>
